import './logo.css'

const LOGO_TGP = '/logo_tgp_vision_consultores_color.png'

const SpinnerComponent = () => {
  return (
    <div className='tgp-loader tgp-loader--page' role='status' aria-label='Cargando'>
      <div className='tgp-loader__mark'>
        <img className='tgp-loader__logo' src={LOGO_TGP} alt='TGP' />
      </div>
    </div>
  )
}

export default SpinnerComponent
